import { useContext } from 'react';
import { ErrorHandlerContext } from './ErrorHandlerContext';

export const useErrorHandler = () => {
  const { errorHandler } = useContext(ErrorHandlerContext);
  return errorHandler;
};
